// Builds a YouTube search URL for an exercise demo video.
// Prefers curated search_query (Italian), falls back to name + tutorial.
export function youtubeSearchUrl({ name, search_query }) {
  const q = (search_query && search_query.trim()) || `${name} tutorial forma corretta`;
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(q)}`;
}

export function openDemoVideo(ex) {
  window.open(youtubeSearchUrl(ex), "_blank", "noopener,noreferrer");
}
